<template lang="pug">
  div
    v-row(no-gutters class="mb-2")
      h3(class="headline font-weight-bold") Описание
    v-row(no-gutters align="center" justify="start" class="mr-6")
      v-col(cols="6" v-for="item in advertItem.items", :key="item.id", class="d-flex justify-space-between py-0 px-6")
        span(class="subtitle-1") {{ item.title }}
        span(class="subtitle-1 font-weight-bold pl-1" style="color: #333") {{ item.value }}
    v-divider(class="my-3")
    v-row(no-gutters)
      p(class="subtitle-1") {{ advertItem.description }}
</template>

<script>
export default {
  name: 'PageDescription',
  props: {
    advertItem: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>
